/**
 * Select the way od the store is run.
 */
const store = process.env.NODE_ENV === 'production'
  ? require('./store.prod')
  : require('./store.dev');

module.exports = store;
